// components/ComboDisplay/Events/TakeDownGroupComponent.tsx

import React, { useContext } from 'react';

import './TakeDownGroupComponent.css';
import GameAssetsContext from '../../../../../../../context/GameAssetContext';
import { TakeDownGroup } from '../../utils';
import LogEntry from '../../LogEntry';
import StackEvent from '../TimeOutEvents/StackEvent';

interface TakeDownGroupProps {
  group: TakeDownGroup;
  casterChampionName: string; // Add caster champion name prop
  showStackingEvents?: boolean; // Add prop to control stack event display
}

const TakeDownGroupComponent: React.FC<TakeDownGroupProps> = ({ 
  group, 
  casterChampionName,
  showStackingEvents = true 
}) => {
  const { takeDownEvent, relatedEvents } = group;
  const { championsAssets } = useContext(GameAssetsContext);

  // Extract information about the champion who was taken down
  const targetChampionName = takeDownEvent.details.targetName!;
  const targetChampionAssets = championsAssets[targetChampionName];
  const targetChampionImageUrl = targetChampionAssets?.championImageUrl;

  // Get caster champion assets
  const casterAssets = championsAssets[casterChampionName];
  const casterImage = casterAssets?.championImageUrl;

  // Categorize events similar to KeyPressGroup
  const stackEvents = relatedEvents.filter(event => event.type === 'StackUpdate');
  const nonStackEvents = relatedEvents.filter(event => event.type !== 'StackUpdate');

  // Check if we should show the stack divider
  const shouldShowStackDivider = showStackingEvents && 
    stackEvents.length > 0 && 
    nonStackEvents.length > 0;

  return (
    <div className="take-down-group-container">
      {/* Target champion image (greyed out) */}
      <div className="target-champion-takedown-container">
        <img
          src={targetChampionImageUrl}
          alt={targetChampionName}
          className="greyed-out-champion-image"
        />
      </div>

      {/* Caster events section (if there are non-stack related events) */}
      {nonStackEvents.length > 0 && (
        <>
          <div className="kpg-divider"></div>
          <div className="kpg-caster-events">
            <div className="kpg-champion-header">
              <img
                src={casterImage}
                alt={casterChampionName}
                className="kpg-champion-image-ally"
              />
            </div>
            <div className="kpg-takedown-events">
              {nonStackEvents.map((event) => (
                <LogEntry key={event.id} log={event} />
              ))}
            </div>
          </div>
        </>
      )}

      {/* Stack Events Section - Similar to KeyPressGroup */}
      {showStackingEvents && stackEvents.length > 0 && (
        <>
          {shouldShowStackDivider && <div className="kpg-divider"></div>}
          <div className="kpg-stack-events">
            {stackEvents.map((event) => (
              <div key={event.id}>
                <StackEvent log={event} />
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TakeDownGroupComponent;
